import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import { inRoomDiningAddOnSelector, inRoomDiningItemsSelector } from '../../../servicesSlice';
import { selectedHotelCurrencySelector } from '../../../../property/propertySlice';
import { getCurrencyNameFromCode } from '../../../../../utils/commonUtils';

const InRoomDiningComboViewDetail = ({ tabValue, combo }) => {
  const itemsList = useSelector(inRoomDiningItemsSelector);
  const addonsList = useSelector(inRoomDiningAddOnSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const [itemAddons, setItemAddons] = useState(null);

  const [dataList, setDataList] = useState({
    itemsList: [],
    addonsList: [],
    upsellList: [],
  });

  useEffect(() => {
    if (combo) {
      setData();
    }
  }, [itemsList, combo, addonsList]);

  const setData = () => {
    let comboItems = [];
    let comboAddons = [];
    let upsellItems = [];
    if (combo && combo?.items?.length > 0 && itemsList && itemsList?.length > 0) {
      comboItems = combo?.items?.map((itemsId) => {
        const items = itemsList?.find((item) => item?.id === itemsId);
        if (items) return items;
      });
    }
    if (combo && combo?.addons && addonsList && addonsList?.length > 0) {
      let currAddon = null;
      if (combo?.addons?.type === 'INACTIVE') {
        currAddon = null;
      } else {
        currAddon = { ...combo?.addons };
        if (currAddon?.type === 'GROUPED') {
          const groupedAddon = currAddon?.groupedAddon?.map((groupedAddon) => {
            const addonItem = groupedAddon?.addons?.map((addonItem) => {
              const getAddon = addonsList?.find((addonsDetails) => addonsDetails?.id === addonItem);
              return getAddon?.name;
            });
            return { ...groupedAddon, addons: addonItem };
          });
          currAddon.groupedAddon = groupedAddon;
        } else {
          const unGroupedAddons = currAddon?.addons?.map((addonItem) => {
            const getAddon = addonsList?.find((addonsDetails) => addonsDetails?.id === addonItem);
            return getAddon?.name;
          });
          currAddon.unGroupedAddons = unGroupedAddons;
        }
        setItemAddons(currAddon);
      }
    } else {
      setItemAddons(null);
    }
    if (
      combo &&
      combo?.upsell &&
      combo.upsell?.items?.length > 0 &&
      addonsList &&
      addonsList?.length > 0
    ) {
      upsellItems = combo?.upsell?.items?.map((itemsId) => {
        const items = itemsList?.find((item) => item?.id === itemsId);
        if (items) return items;
      });
    }
    setDataList({
      itemsList: comboItems,
      addonsList: comboAddons,
      upsellList: upsellItems,
    });
  };

  return (
    <div className='row mx-4 mt-4'>
      {tabValue === 0 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Combo Name</div>
            <div className='details-value preview-breaks'>{combo.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label text-center'>Status</div>
            <div
              className={`${
                combo.status ? 'pill-active' : 'pill-inactive'
              } col-md-3 pill-text pill container`}
            >
              <span>{combo.status ? 'Active' : 'Inactive'}</span>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Combo Code</div>
            <div className='details-value'>{combo.code}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>
              {combo?.description ? combo?.description : '---'}
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Combo Price</div>
            <div className='details-value'>
              {getCurrencyNameFromCode(currency)} {combo.price}
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Items</div>
            <div className='details-value'>
              {dataList?.itemsList &&
                dataList?.itemsList?.length > 0 &&
                dataList.itemsList.map((items) => <div key={items?.id}>{items?.name}</div>)}
              {dataList?.itemsList?.length === 0 && <div>---</div>}
            </div>
          </div>
          {combo?.customAttributes &&
            combo?.customAttributes?.length > 0 &&
            combo?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      )}
      {tabValue === 1 && (
        <>
          {itemAddons && itemAddons?.type !== 'INACTIVE' ? (
            <>
              <div className='col-md-12'>
                <div className='details-label mb-2'>Add-Ons</div>
                <p className='text-black'>
                  {itemAddons?.type.charAt(0).toUpperCase() +
                    itemAddons?.type.slice(1).toLowerCase()}
                </p>
                {itemAddons?.type === 'GROUPED' ? (
                  <>
                    <div className='details-label mb-2 mt-2'>Add-on Groups</div>
                    {itemAddons.groupedAddon.map((addonItem, index) => (
                      <p className='text-black' key={index}>
                        {addonItem?.title}
                        {`(${addonItem?.limit})`}:
                        {addonItem?.addons?.map((adddon) => adddon)?.join(', ')}
                      </p>
                    ))}
                  </>
                ) : (
                  <>
                    <div className='details-label mb-2 mt-2'>Add-on Names</div>
                    <p>{itemAddons?.unGroupedAddons?.map((addonItem) => addonItem)?.join(', ')}</p>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <div className='col-md-6'>
                <div className='details-label'>No AddOns Available</div>
              </div>
            </>
          )}
        </>
      )}
      {tabValue === 2 && (
        <>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>
              {dataList?.upsellList?.length ? 'Upsell Items' : 'No Upsell Items Available'}
            </div>
            <div className='details-value'>
              {dataList?.upsellList &&
                dataList?.upsellList?.length > 0 &&
                dataList.upsellList.map((upsell) => <div key={upsell.id}>{upsell.name}</div>)}
            </div>
          </div>
        </>
      )}
      {tabValue === 3 && (
        <MediaViewer
          images={combo.images}
          videos={combo.videos}
          gifs={combo.gifs}
          enabledMediaTabs={['image']}
        />
      )}
    </div>
  );
};

export default InRoomDiningComboViewDetail;
